<template>
    <app-dialog
        :open="open"
        :title="resolvedTitle"
        :title-id="headlineId"
        size="lg"
        body-class="p-0"
        @close="$emit('close')"
    >
        <p v-if="text" class="border-b border-ultralight px-8 pb-5 pt-6 text-sm leading-6 text-gray-500 sm:px-10">
            {{ text }}
        </p>
        <div class="max-h-[32rem] overflow-y-auto bg-white">
                        <div v-if="moduleTypes.length < 1" class="px-6 py-5 text-sm text-gray-500">
                            {{ $t('Für diesen Slot stehen aktuell keine Presets zur Auswahl.') }}
                        </div>
                        <button
                            v-for="moduleType in moduleTypes"
                            :key="moduleType.id"
                            type="button"
                            class="flex w-full items-start justify-between gap-6 border-b border-gray-100 px-6 py-4 text-left transition hover:bg-gray-50"
                            @click="$emit('select', moduleType)"
                        >
                            <div class="min-w-0 flex-1">
                                <div class="text-sm font-medium leading-6 text-gray-900">
                                    {{ moduleType.name }}
                                </div>
                                <div v-if="moduleType.description" class="mt-1 text-xs leading-5 text-gray-500">
                                    {{ moduleType.description }}
                                </div>
                            </div>
                        </button>
        </div>
    </app-dialog>
</template>

<script>
import AppDialog from '@/components/modals/app-dialog.vue';

export default {
    name: 'module-type-picker-dialog',
    components: {AppDialog},
    props: {
        open: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        moduleTypes: {
            type: Array,
            default: () => [],
        },
        headlineId: {
            type: String,
            default: 'module-type-picker-dialog-headline',
        },
    },
    emits: ['select', 'close'],
    computed: {
        resolvedTitle() {
            return this.title || this.$t('Modul-Preset wählen');
        },
    },
};
</script>
